
import { useNavigate } from 'react-router-dom';

export default function CrossLinkBanner() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/tokyo-airbnb-support');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section
      className="relative py-16"
      style={{
        background: 'linear-gradient(135deg, #f5e6c8 0%, #ede0c4 100%)',
        fontFamily: "'Noto Serif JP', serif",
      }}
    >
      {/* 上部装飾ライン */}
      <div className="w-full h-2 flex overflow-hidden">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-2"
            style={{ backgroundColor: i % 2 === 0 ? '#8B2500' : '#c8a96e' }}
          />
        ))}
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="relative p-10 rounded-lg"
          style={{
            background: 'linear-gradient(135deg, #fdf6e3 0%, #f5e6c8 100%)',
            border: '2px solid #8B2500',
          }}
        >
          {/* 四隅装飾 */}
          <div className="absolute top-3 left-3 w-6 h-6 border-t-2 border-l-2" style={{ borderColor: '#8B2500' }} />
          <div className="absolute top-3 right-3 w-6 h-6 border-t-2 border-r-2" style={{ borderColor: '#8B2500' }} />
          <div className="absolute bottom-3 left-3 w-6 h-6 border-b-2 border-l-2" style={{ borderColor: '#8B2500' }} />
          <div className="absolute bottom-3 right-3 w-6 h-6 border-b-2 border-r-2" style={{ borderColor: '#8B2500' }} />

          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* アイコン */}
            <div
              className="flex-shrink-0 w-20 h-20 rounded-full flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, #7A1A28 0%, #9B2335 100%)',
              }}
            >
              <i className="ri-home-heart-line text-3xl" style={{ color: '#fdf6e3' }}></i>
            </div>

            {/* テキスト */}
            <div className="flex-1 text-center md:text-left">
              <div className="flex flex-wrap gap-2 justify-center md:justify-start mb-3">
                <span
                  className="px-3 py-1 text-xs font-medium rounded-full"
                  style={{
                    border: '1px solid #8B2500',
                    color: '#8B2500',
                    background: 'linear-gradient(135deg, #fdf6e3 0%, #f5e6c8 100%)',
                  }}
                >
                  開業サポート
                </span>
                <span
                  className="px-3 py-1 text-xs font-medium rounded-full"
                  style={{
                    border: '1px solid #c8a96e',
                    color: '#6b4c2a',
                    background: 'linear-gradient(135deg, #fdf6e3 0%, #f5e6c8 100%)',
                  }}
                >
                  運営代行
                </span>
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ color: '#3d1f0a' }}>
                民泊・簡易宿所の開業をお考えの方へ
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#6b4c2a' }}>
                申請サポートから運営代行まで、トータルでサポートいたします
              </p>
            </div>

            {/* CTAボタン */}
            <button
              onClick={handleClick}
              className="group flex-shrink-0 px-8 py-4 rounded-md font-semibold text-base transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              style={{
                background: 'linear-gradient(135deg, #7A1A28 0%, #9B2335 100%)',
                color: '#fdf6e3',
              }}
              onMouseEnter={e => (e.currentTarget.style.background = 'linear-gradient(135deg, #9B2335 0%, #C8960C 100%)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'linear-gradient(135deg, #7A1A28 0%, #9B2335 100%)')}
            >
              <span className="flex items-center gap-2">
                詳しく見る
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* 下部装飾ライン */}
      <div className="w-full h-2 flex overflow-hidden mt-0">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-2"
            style={{ backgroundColor: i % 2 === 0 ? '#c8a96e' : '#8B2500' }}
          />
        ))}
      </div>

      {/* 区切り線 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div
          className="h-px"
          style={{
            background: 'linear-gradient(to right, transparent, #c8a96e 20%, #c8a96e 80%, transparent)',
          }}
        />
      </div>
    </section>
  );
}